import { type OpenApiSchemaProblem } from '../../../api/schema';

export function isSchemaProblemError(error: unknown): error is { responseData: OpenApiSchemaProblem } {
    return Boolean(
        error instanceof Error &&
            'responseData' in error &&
            error.responseData &&
            typeof error.responseData === 'object' &&
            'type' in error.responseData &&
            typeof error.responseData.type === 'string' &&
            'status' in error.responseData &&
            typeof error.responseData.status === 'number'
    );
}
